import { combineReducers } from "redux";

import need_advice from "../features/admin/need_advice/slice";

const GetNeedAdvice = combineReducers({
  need_advice: need_advice,
});

export default GetNeedAdvice;
